import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import LoadingButton from "@mui/lab/LoadingButton";
import { useAlert } from "../../../services/alert";
import { useApiTenant } from "../../../api/api-tenant";
export default function TicketDetailsDelete({ ticketId, detailToDelete, setDetailToDelete, }) {
    const { t } = useTranslation();
    const alert = useAlert();
    const api = useApiTenant();
    const [isDeleting, setIsDeleting] = useState(false);
    const deleteTicketDetail = () => {
        setIsDeleting(true);
        api.DELETE_ticketDetail(detailToDelete, ticketId)
            .then(() => {
            alert.show(t("tickets.ticket-details.ticket-details-delete.details-deleted"), "warning");
            setIsDeleting(false);
            setDetailToDelete("");
        })
            .catch(error => {
            console.error(error.response);
            setIsDeleting(false);
            alert.show(t("tickets.ticket-details.ticket-details-delete.deleting-error"), "error");
        });
    };
    return (_jsxs(Dialog, Object.assign({ open: detailToDelete !== "", onClose: () => {
            setDetailToDelete("");
        } }, { children: [_jsx(DialogTitle, { children: t("delete-component.confirm") }), _jsxs(DialogContent, { children: [_jsx(DialogContentText, { children: t("tickets.ticket-details.ticket-details-delete.confirm") }), _jsx(DialogContentText, { children: _jsx("em", { children: t("delete-component.confirm-caption") }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, Object.assign({ color: "inherit", onClick: () => {
                            setDetailToDelete("");
                        } }, { children: t("cancel") })), _jsx(LoadingButton, Object.assign({ type: "button", variant: "text", color: "inherit", size: "small", loading: isDeleting, onClick: () => deleteTicketDetail(), loadingIndicator: _jsx(CircularProgress, { color: "inherit", size: 16 }), style: {
                            color: "rgb(244, 67, 54)",
                        } }, { children: t("tickets.ticket-details.ticket-details-delete.remove") }))] })] })));
}
